import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { toast } from 'sonner';
import { Plus, Trash2 } from 'lucide-react';

const CATS = ['Training', 'Nutrition', 'Recovery', 'Mindset', 'Longevity'];

export default function AdminTips() {
  const [tips, setTips] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ title: '', category: 'Training', content_type: 'article', body: '', media_url: '' });

  const load = async () => { const r = await api.get('/tips'); setTips(r.data); };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try { await api.post('/tips', f); setOpen(false); load(); toast.success('Created'); }
    catch { toast.error('Failed'); }
  };
  const del = async (id) => { if (!confirm('Delete?')) return; await api.delete(`/tips/${id}`); load(); };

  return (
    <div className="space-y-6" data-testid="admin-tips">
      <div className="flex items-end justify-between">
        <div><div className="label-mini text-[#FFB800]">Content</div><h1 className="font-display font-black text-4xl mt-1">Tips Library</h1></div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="add-tip-btn" className="bg-[#FFB800] text-[#081726] font-semibold"><Plus className="w-4 h-4 mr-2" /> New Tip</Button></DialogTrigger>
          <DialogContent className="bg-regen-card border-[var(--c-hair)] max-w-lg max-h-[90vh] overflow-y-auto">
            <DialogHeader><DialogTitle>New Tip</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Title</Label><Input value={f.title} onChange={e => setF({...f, title: e.target.value})} data-testid="tip-title" className="bg-transparent border-[var(--c-hair)]" /></div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Category</Label>
                  <Select value={f.category} onValueChange={v => setF({...f, category: v})}>
                    <SelectTrigger className="bg-transparent border-[var(--c-hair)]"><SelectValue /></SelectTrigger>
                    <SelectContent>{CATS.map(c => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
                  </Select>
                </div>
                <div><Label>Type</Label>
                  <Select value={f.content_type} onValueChange={v => setF({...f, content_type: v})}>
                    <SelectTrigger className="bg-transparent border-[var(--c-hair)]"><SelectValue /></SelectTrigger>
                    <SelectContent><SelectItem value="article">Article</SelectItem><SelectItem value="video">Video</SelectItem><SelectItem value="image">Image</SelectItem></SelectContent>
                  </Select>
                </div>
              </div>
              <div><Label>Media URL</Label><Input value={f.media_url} onChange={e => setF({...f, media_url: e.target.value})} className="bg-transparent border-[var(--c-hair)]" /></div>
              <div><Label>Body</Label><Textarea value={f.body} onChange={e => setF({...f, body: e.target.value})} rows={6} className="bg-transparent border-[var(--c-hair)]" /></div>
              <Button onClick={save} data-testid="tip-save" className="w-full bg-[#FFB800] text-[#081726] font-semibold">Save</Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {tips.map(t => (
          <div key={t.id} className="regen-card-elevated overflow-hidden group" data-testid={`tip-${t.id}`}>
            {t.media_url && <img src={t.media_url} alt={t.title} className="w-full h-32 object-cover" />}
            <div className="p-4">
              <div className="label-mini text-[#FFB800]">{t.category} · {t.content_type}</div>
              <div className="font-display font-bold mt-1">{t.title}</div>
              <div className="text-xs text-muted-foreground mt-1 line-clamp-2">{t.body}</div>
              <Button size="sm" variant="ghost" onClick={() => del(t.id)} className="mt-2 opacity-0 group-hover:opacity-100"><Trash2 className="w-3 h-3 text-red-400" /></Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
